export const LAST_LOGIN_DATE_FORMAT = 'dd-MM-yy';
